import { render, staticRenderFns } from "./brand-record.vue?vue&type=template&id=42aae530&scoped=true&"
import script from "./brand-record.vue?vue&type=script&lang=js&"
export * from "./brand-record.vue?vue&type=script&lang=js&"
import style0 from "./brand-record.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./brand-record.vue?vue&type=style&index=1&id=42aae530&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aae530",
  null
  
)

export default component.exports